"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEXP_BILLINGS_SOURCE = void 0;
exports.REGEXP_BILLINGS_SOURCE = /^[A-z0-9.:/_-]+$/; // Дефис ставим в конце чтобы не было проблем
//# sourceMappingURL=billings-source.regexp.js.map